/**
 * @generated SignedSource<<5f06c790e774be7cd591a4dba3a2179f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelRemoveIntegrationMutation$variables = {
  salesChannelID?: string | null;
};
export type salesChannelRemoveIntegrationMutation$data = {
  readonly removeEcommerceSettings: boolean;
};
export type salesChannelRemoveIntegrationMutation = {
  response: salesChannelRemoveIntegrationMutation$data;
  variables: salesChannelRemoveIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "kind": "ScalarField",
    "name": "removeEcommerceSettings",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelRemoveIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "salesChannelRemoveIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4bdff612e25e57ee3b443265a8581b0d",
    "id": null,
    "metadata": {},
    "name": "salesChannelRemoveIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelRemoveIntegrationMutation(\n  $salesChannelID: ID\n) {\n  removeEcommerceSettings(salesChannelID: $salesChannelID)\n}\n"
  }
};
})();

(node as any).hash = "2e71d0a0ea85edc26df6978704aea129";

export default node;
